import { render, staticRenderFns } from "./OrdinaryPlate.vue?vue&type=template&id=c30a113e&scoped=true&"
import script from "./OrdinaryPlate.vue?vue&type=script&lang=js&"
export * from "./OrdinaryPlate.vue?vue&type=script&lang=js&"
import style0 from "./OrdinaryPlate.vue?vue&type=style&index=0&id=c30a113e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30a113e",
  null
  
)

component.options.__file = "OrdinaryPlate.vue"
export default component.exports